import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { SHOP_URL } from "../mock";

const points = [
  "Simply hand tighten — no crimping",
  "Reusable, over and over again",
  "Fits a wide range of wire sizes",
  "Won't vibrate loose on the road",
];

const About = () => {
  return (
    <section id="about" className="relative bg-[#f5f5f6] py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* Copy */}
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#f15a24]">
              Requires no crimping
            </span>
            <h2 className="font-display font-semibold text-neutral-900 text-4xl sm:text-5xl mt-4 leading-tight">
              A connector built for the 21st century
            </h2>
            <p className="text-neutral-600 text-lg mt-6 leading-relaxed">
              Posi connectors simply hand tighten. An electrical connector that
              meets the needs of today's OEMs, and is so good, it's reusable —
              truly a connector for the modern age.
            </p>

            <ul className="mt-8 space-y-3">
              {points.map((p) => (
                <li key={p} className="flex items-center gap-3">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-[#f15a24] text-white shrink-0">
                    <Check size={14} strokeWidth={3} />
                  </span>
                  <span className="text-neutral-700">{p}</span>
                </li>
              ))}
            </ul>

            <a
              href={SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-9 inline-flex items-center gap-2 bg-[#f15a24] hover:bg-[#ff6a34] text-white font-semibold px-7 py-3.5 rounded-full transition-all duration-300 shadow-lg shadow-[#f15a24]/25 hover:-translate-y-0.5"
            >
              More about us
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="relative bg-[#0e0e10] rounded-3xl p-8 shadow-2xl overflow-hidden">
              <div className="absolute -bottom-16 -right-16 w-64 h-64 bg-[#f15a24]/20 rounded-full blur-3xl" />
              <img
                src="https://www.motousher.com/cdn/shop/products/PosiSealConnectors.jpg?v=1676947492&width=600"
                alt="Range of Posi connectors"
                className="relative w-full rounded-2xl bg-white object-contain"
              />
              <div className="relative mt-6 border border-[#f15a24]/50 rounded-xl py-3 px-4 text-center">
                <span className="text-[#f15a24] font-semibold tracking-wide">
                  Revolutionizing connector technology!
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
